import React from "react";
import QuoteContent from "./QuoteContent";

const QuotePreview = ({ quote }) => {
  if (!quote) return null;

  return (
    <div>
      <h3>Preview</h3>
      <div style={{ border: "1px solid #999", marginBottom: "20px", padding: "10px" }}>
        <QuoteContent quote={quote} page="1" />
      </div>
      <div style={{ border: "1px solid #999", padding: "10px" }}>
        <QuoteContent quote={quote} page="2" />
      </div>
      {quote.pdfUrl && (
        <div style={{ marginTop: "20px" }}>
          <a href={quote.pdfUrl} target="_blank" rel="noopener noreferrer">
            🔗 Open PDF in Viewer
          </a>
          <button
            onClick={() => {
              navigator.clipboard.writeText(quote.pdfUrl);
              alert("📋 PDF link copied to clipboard!");
            }}
            style={{ marginTop: "10px", padding: "6px 12px", cursor: "pointer" }}
          >
            Copy PDF Link
          </button>
        </div>
      )}
    </div>
  );
};

export default QuotePreview;
